export const integrationBadges = [
  { label: 'Garmin', color: '#00AEEF' },
  { label: 'Apple Health', note: 'iOS coming soon', color: '#FF3B30' },
  { label: 'GPT-4', color: '#63DE77' },
  { label: 'Body Journal', color: '#877FFC' },
];

export const pillars = [
  {
    title: 'Activity',
    icon: '🏃',
    color: 'rgba(35, 136, 255, 0.1)',
    description: 'Running, cycling, strength and Garmin workouts - analysed and contextualised automatically.',
    meta: 'Garmin - Manual entry',
  },
  {
    title: 'Sleep & Recovery',
    icon: '🌙',
    color: 'rgba(135, 127, 252, 0.1)',
    description: 'High-frequency sleep data with its own dedicated view. Know when to push and when to rest.',
    meta: 'HRV - Sleep stages - Resting HR',
  },
  {
    title: 'Body Metrics',
    icon: '💚',
    color: 'rgba(99, 222, 119, 0.09)',
    description: 'Body composition, blood pressure, blood work. Track what matters, over time.',
    meta: 'Periodic - Manual entry',
  },
  {
    title: 'Intake',
    icon: '🥗',
    color: 'rgba(255, 114, 248, 0.09)',
    description: 'Nutrition and supplementation tracked together. Understand how what you eat affects how you perform.',
    meta: 'Nutrition - Supplements',
  },
  {
    title: 'Wellness & External Factors',
    icon: '🧠',
    color: 'rgba(35, 136, 255, 0.09)',
    description: 'Mood, stress, energy, travel, illness. The why behind your numbers - finally captured.',
    meta: 'Mood - Stress - Energy - Environment',
  },
  {
    title: "Women's Health",
    icon: '💜',
    color: 'rgba(255, 114, 248, 0.1)',
    description: 'Cycle, fertility and hormonal health - a dedicated pillar built in from the start, not bolted on.',
    meta: 'Cycle - Fertility - Menopause',
  },
];

export const coachHighlights = [
  'Powered by GPT-4 with your actual health data as context',
  'Understands your trends, not just today\'s numbers',
  'AI-driven suggestions on what to ask next',
];

export const coachMessages = [
  {
    from: 'You',
    time: '08:14',
    text: 'Why did my HRV drop this week even though I slept well?',
  },
  {
    from: 'BodyLytiX Coach',
    time: '08:14',
    text: 'Your sleep quality was solid (avg 76/100) but your training load was 34% above your 30-day average - three sessions in Zone 4. Your body is still absorbing that stress. HRV typically rebounds within 48-72 hours of reduced intensity.',
  },
  {
    from: 'You',
    time: '08:15',
    text: 'Should I train today or rest?',
  },
  {
    from: 'BodyLytiX Coach',
    time: '08:15',
    text: 'Your HRV is 58ms - up from 51ms yesterday - and trending in the right direction. Zone 2 cardio or mobility work today would support recovery without adding stress. Hold off on high intensity until you are back above your 30-day average of 62ms.',
  },
];

export const suggestedQuestions = [
  'What was my best week this month?',
  'Analyse my sleep pattern',
  "How's my fitness age tracking?",
];

export const steps = [
  {
    number: '01',
    title: 'Connect your devices',
    description: 'Link Garmin and Apple Health. Your activity, sleep and health data syncs automatically.',
  },
  {
    number: '02',
    title: 'Log what the devices miss',
    description: 'Add mood, nutrition, stress, body metrics and wellness check-ins via the Body Journal.',
  },
  {
    number: '03',
    title: 'Ask your AI coach',
    description: 'Ask anything. Your coach reads all six data pillars and answers with your actual numbers as context.',
  },
  {
    number: '04',
    title: 'Track what changes',
    description: 'Your Daily Performance Score and trends show you whether what you are doing is actually working.',
  },
];

export const blogPosts = [
  {
    author: 'BodyLytiX Team',
    date: 'May 2026',
    title: 'Why we built BodyLytiX and what we got wrong first',
    short_description: 'The honest story of building a health data platform from scratch, the early mistakes and what changed when we listened to real users.',
  },
  {
    author: 'BodyLytiX Team',
    date: 'May 2026',
    title: 'HRV: the metric most people track but few actually understand',
    short_description: 'What heart rate variability actually tells you, why context matters more than the number and how BodyLytiX uses it.',
  },
  {
    author: 'BodyLytiX Team',
    date: 'May 2026',
    title: 'The six data pillars and why most fitness apps only cover two',
    short_description: 'Activity and sleep are just the start. Wellness factors, intake, body metrics and women\'s health complete the picture.',
  },
];

export const socialLinks = [
  { label: 'Discord', href: 'https://discord.gg/NssqZfs4' },
  { label: 'X', href: 'https://x.com/bodylytiX' },
  { label: 'Instagram', href: 'https://www.instagram.com/bodylytix' },
];
